import { render, staticRenderFns } from "./GeneralMail.vue?vue&type=template&id=471b6222&scoped=true&"
import script from "./GeneralMail.vue?vue&type=script&lang=js&"
export * from "./GeneralMail.vue?vue&type=script&lang=js&"
import style0 from "./GeneralMail.vue?vue&type=style&index=0&id=471b6222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471b6222",
  null
  
)

export default component.exports